var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.group && _vm.group[0].fields.specfeatureGroup
    ? _c(
        "div",
        { staticClass: "w-full lg:container features__table" },
        _vm._l(
          _vm.group[0].fields.specfeatureGroup,
          function (featureGroup, index) {
            return _c("ProductFeatureGroup", {
              key: `feature-group-${index}`,
              attrs: {
                product: _vm.product,
                length: _vm.length,
                "feature-group": featureGroup,
                index: index,
                "expand-all": _vm.expanded,
                group: _vm.group,
                specs: _vm.specs,
                activeProduct: _vm.activeProduct,
                "expand-inner": _vm.expandInnerAll,
              },
            })
          }
        ),
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }